import styles from './index.module.scss';
import { useLang } from '@/i18n';
import { useState } from 'react';
import PartnerModal from '../PartnerModal';
import EcoImg from 'eco-design/base/eco-img';

const SuperchargeSolarSection = () => {
    const { t } = useLang('theProduct.SuperchargeSolarStatusC');
    const [modalVisible, setModalVisible] = useState(false);

    return (
        <section className={styles.SuperchargeSolarStatusC}>
            <EcoImg
                pc="https://websiteoss.ecoflow.com/upload/image/1751863092792/supper-card-pc.jpg"
                h5="https://websiteoss.ecoflow.com/upload/image/1751863082948/supper-card-h5.jpg"
            />

            <div className="text-container">
                <h2 className="h2">{t(`title`)}</h2>
                <button className="primary-btn" onClick={() => setModalVisible(true)}>
                    {t(`btn`)}
                </button>
            </div>
            <PartnerModal visible={modalVisible} onClose={() => setModalVisible(false)} />
        </section>
    );
};

export default SuperchargeSolarSection;
